<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col>
            <v-col >
               <v-select
                  :items=partCategories
                  label="Κατηγορία Ανταλλακτικού"
                  v-model="category"
                  :hint="`Cat-ID: ${category}`"
                  persistent-hint
                  item-text="Description"
                  item-value="CatId"
                  clearable
                ></v-select>
            </v-col>
            <v-col>
              <v-combobox
                v-model="manf"
                :items="uniqueManufacturers"
                prepend-icon="mdi-factory"
                label="Κατασκευαστής"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(manf, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col>
              <v-combobox
                v-model="supplier"
                :items="uniqueSuppliers"
                prepend-icon="mdi-warehouse"
                label="Προμηθευτής"
                clearable
              >
                <template v-slot:selection="{ attrs, item }">
                  {{ item.Name }}
                  </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.Name"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.Address"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols=2>
               <v-switch
                  v-model="inStock"
                  label="Σε απόθεμα"
                ></v-switch>
            </v-col>
              </v-row>

        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Λίστα Παραγγελιών</h1>
       <v-spacer/>

    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="filteredOrders"
      loading: false
      :search="search"
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      single-expand: true
      :expanded.sync="expanded"
      sort-desc
      sort-by="Id"
      show-group-by
      loading-text="Loading... Please wait"
    >
    <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          :to="{name: 'order-info', params: {id: item.Id}}"
        >
         <v-icon>mdi-dolly</v-icon>
        </v-btn>
         <v-btn
          icon
          small
          :to="{name: 'part-info', params: {id: item.PartInfo.Id}}"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
          <v-btn
          v-if="item.Invoice"
          icon
          small
          :to="{name: 'distributor-order-checkin', params: {invoiceId: item.Invoice.Id}}"
        >
         <v-icon>mdi-file-document</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="generateLabel(item)"
        >
          <v-icon>mdi-sticker-outline</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.RetailPrice="{ item }">
       {{ tocurr(item.RetailPrice*(1-item.Discount)) }}
    </template>
    <template v-slot:item.SuggestedPrice="{ item }">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >      {{ $tocurr(item.SuggestedPrice) }}</span>
      </template>
      <span>{{((item.SuggestedPrice/item.PartCost-1)*100).toFixed(0)}}% - {{$tocurr(item.SuggestedPrice-item.PartCost)}}</span>
    </v-tooltip>
    </template>
    <template v-slot:item.Timestamp="{ item }">
       {{ item.Timestamp.split('T')[0] }}
    </template>
     <template v-slot:item.CategoryId="{ item }">
       {{ partCategories.find(i => i.CatId === item.PartInfo.CategoryId).Description }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
       <tr>
      <td :colspan="headers.length">
        More info about {{ item.FmSku }}
        <p>Related invoices:</p>
      </td>
      </tr>
      <v-list-item v-for='i in item.Orders' :key=i.Id>
            <v-list-item-content>
             <v-list-item-title> {{ i.Id }}
               <v-btn
                    icon
                    :to="'/invoice/details/'+i.Id"
                  >
                  <v-icon>mdi-git</v-icon>
                  </v-btn>
             </v-list-item-title>
             {{ i.Manufacturer }} - {{ i.ManufacturerSku }} - {{ i.SupplierSku }}
            </v-list-item-content>
            </v-list-item>
    </template>
    </v-data-table>
  </v-card>
</template>

<PrintDialog
  :item="labelItem"
  :showDialog="printDialog"
  @close="handleDialogClose"
/>



  </v-container>
</template>

<script>

import PrintDialog from '../components/PrintLabelDialog.vue';


export default {
  components: {
    PrintDialog
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
      partsCost () {
        return this.parts.reduce((a, b) => a + (b.StockCost || 0), 0);
      },
      partsSaleValue () {
        return this.parts.reduce((a, b) => a + (b.SaleValue || 0), 0);
      },
      isAdmin() {
          if (!this.$store.state.authentication.user) return false;
          return this.$store.state.authentication.user.scopes.includes("income");
      },
     uniqueManufacturers () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniq(this.parts, 'Manufacturer');
    },
    filteredOrders() {
      if (!this.supplier) return this.parts;
      return this.parts.filter(e => e.Invoice.Supplier.Id == this.supplier.Id);
    },
  },
  data() {
    return {
      menu: false,
      expanded: [],
      checkoutdialog: false,
      partQty: 0,
      partTechId: 1,
      loading: true,
      newPart: {CategoryId: 0},
      partCategories: [],
      search: '',
      inStock: false,
      parts: [],
      manf: [],
      category: null,
      supplier: null,
      printDialog: false,
      labelItem: null, // Item for which the label is being generated
      uniqueSuppliers: [],
      rules:  {
        partId: value => {
            const pattern = /^\d{1,5}$/
            return pattern.test(value) || 'Invalid Part-ID.'
          },
      },
      headers: [
            {
            text: 'Α/Α',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
           { text: 'Ημ/νια', value: 'Timestamp', align: 'start' },
          {
            text: 'Κωδικός',
            align: 'start',
            //sortable: false,
            value: 'PartInfo.FmSku',
            width: '5%',
          },
          {
            text: 'Κωδικός Προμηθευτή',
            align: 'start',
            //sortable: false,
            value: 'SupplierSku',

            width: '5%',
          },
          { text: 'Κατηγορία', value: 'PartInfo.CategoryId', groupable: false, width: '5%',
          filter: (value) => {
            if (!this.category) return true;
            return value == this.category;
            },},
            { text: 'Κατασκευαστής', value: 'Manufacturer', groupable: true, width: '20%',
            filter: (value) => {
                if (this.manf.length == 0) return true;
                return this.manf.includes(value);
                }
          },
          { text: 'Περιγραφή', value: 'PartInfo.Description', groupable: false, width: '50%'},

         { text: 'Τιμή χονδρικής', value: 'RetailPrice', align: 'end', groupable: false },
          { text: 'Τιμή λιανικής', value: 'SuggestedPrice', align: 'end', groupable: false },
          { text: 'Απόθεμα', value: 'StockQty', align: 'end', groupable: false,
           filter: (value) => {
            if (!this.inStock) return true;
            return value > 0;
            },
          },
          { text: 'Actions', value: 'actions', groupable: false, width: '25%' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/inventory/orders');
        // console.log(response);
        this.parts = response.data;
        const catresponse = await this.$api.get('/inventory/parts/categories');
        // console.log(response);
        this.partCategories = catresponse.data;
        this.uniqueSuppliers = this.uniqSup(this.parts);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  generateLabel(item) {
    this.labelItem = item;
    this.printDialog = true;
  },
  handleDialogClose () {
    this.printDialog = false;
  },
  close () {
        this.timdialog = false
  },
    async createPart() {
      let part = this.newPart;
      part.References = JSON.parse(this.newPart.References);
      part.PartProperties = JSON.parse(this.newPart.PartProperties);
      var response = await this.$api.post("/inventory/parts/create", part);
      console.log(response);
      this.dialog = false;
    },
  async savePart () {
      let checkout = {
          RepairId: this.repair.Id,
          OrderId: this.order.Id,
          TechId: this.partTechId,
          Qty: this.partQty,
      }
      const resp = await this.$api.post("/inventory/parts/checkout", checkout)
      if (resp.status == 201) {
        alert("Χρεώθηκε")
      try {
        this.loading = true;
        const response = await this.$api.get('/inventory/order/info/'+this.$route.params.id);
        // console.log(response);
        this.order = response.data;
        this.part = this.order.PartInfo;
        const cats = await this.$api.get('/inventory/parts/category/'+this.part.CategoryId)
        this.part.Category = cats.data.Description;
        const techs = await this.$api.get("/repairs/technicians/");
        this.technicians = techs.data;

        const rep = await this.$api.get("/repairs?limit=15");
        this.repairs = rep.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
      }

  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  uniqSup(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let supp = null;
    for (let val of items) {
      //If no invoice, skip
      if (~val["Invoice"]) continue;
      //If item is already added then move to the next item
      supp = val["Invoice"]["Supplier"]
      if (itemsFound[supp.Id]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(supp);

      //Mark it as added
      itemsFound[supp.Id] = true;
    }

    //Return the uniques
    return uniques;
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.manf = [...obj];
  },
 
  }
}
</script>
